import { render, staticRenderFns } from "./roleadd.vue?vue&type=template&id=5c5b647c&scoped=true"
import script from "./roleadd.vue?vue&type=script&lang=js"
export * from "./roleadd.vue?vue&type=script&lang=js"
import style0 from "./roleadd.vue?vue&type=style&index=0&id=5c5b647c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5b647c",
  null
  
)

export default component.exports